var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 10,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEBEC",
  d: "M2.14.121C.989.121.063 1.091.063 2.297V6.96c0 1.205.926 2.176 2.077 2.176h7.714c1.151 0 2.078-.97 2.078-2.176V2.297c0-1.205-.927-2.176-2.078-2.176zm2.67 2.487 3.264 2.02L4.81 6.65z"
})));
export default SvgVideo;